
import {Component, Vue} from "vue-property-decorator";
import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";
import PageTitle from "@/UI/components/common/PageTitle.vue";
@Component({
  components: {PageTitle}
})
export default class WorkerDocs extends Vue {
  loading=false;
  data: any[] = [];
  pagination = {
    showSizeChanger: true,
    pageSize: 10,
    total: 500,
  }
  get workerFilesColumns(): ITableColumn[] {
    return TablesStore.workerFilesColumns;
  }
  created(): void {
    for (let i = 0; i < 100; i++) {
      this.data.push({
        key: (i + 1).toString(),
        name: 'Документ важный.pdf',
        amount: '1.2 МБ',
        date: '26.07.2021',
      })
    }
    this.pagination.total = this.data.length;
  }
}
